// extracted by css-extract-rspack-plugin
var _1 = "PageLoading-m_pageLoading-JrbU3yLa";
export { _1 as "pageLoading" }
